"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _commonCta = require("@mmc/common-cta");
var _formElements = require("@mmc/form-elements");
var _commonRichText = require("@mmc/common-rich-text");
var _themeProvider = require("@mmc/theme-provider");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _close = _interopRequireDefault(require("../../icons/close.svg"));
var _triangle = _interopRequireDefault(require("../../icons/triangle.svg"));
var _enterCode = _interopRequireDefault(require("./enter-code.css"));
var _templateObject;
var getShareCode = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query getConfigSaveCode(\n    $market: String!\n    $language: String!\n    $code: String!\n  ) {\n    getConfigSaveCode(market: $market, language: $language, code: $code) {\n      url\n      code\n      vehicle {\n        id\n        code\n        year\n        name\n        description\n        specifications {\n          label\n          image {\n            image\n            altText\n          }\n          titleAndText {\n            title\n            text\n          }\n        }\n        vehicleImage {\n          image\n          altText\n        }\n        vehicleBackgroundImage {\n          image\n          altText\n        }\n      }\n      model {\n        code\n        name\n        description\n        engineSize\n        engineCode\n        fuelType\n        transmissionType\n        drivetrain\n        image {\n          image\n          altText\n        }\n        exteriorColors {\n          code\n          name\n        }\n      }\n    }\n  }\n"])));
var EnterCode = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(EnterCode, _React$PureComponent);
  function EnterCode(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      getConfigSaveCode: {},
      inputValue: '',
      error: false,
      openTooltip: false
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.submitCode = _this.submitCode.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleTooltip = _this.toggleTooltip.bind((0, _assertThisInitialized2["default"])(_this));
    _this.resetConfigCode = _this.resetConfigCode.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStartNew = _this.onStartNew.bind((0, _assertThisInitialized2["default"])(_this));
    _this.redirectToSavedConfig = _this.redirectToSavedConfig.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKey = _this.handleKey.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = EnterCode.prototype;
  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this.handleKey, false);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKey, false);
  };
  _proto.handleError = function handleError(error) {
    this.setState({
      error: !(0, _isEmpty2["default"])(error)
    });
  };
  _proto.handleChange = function handleChange(_ref) {
    var value = _ref.target.value;
    this.setState({
      inputValue: value
    });
  };
  _proto.handleKey = function handleKey(event) {
    var isEnterKey = event.which === 13;
    if (isEnterKey) {
      return this.submitCode();
    }
    var isEscKey = event.which === 27;
    if (isEscKey) {
      return this.setState({
        openTooltip: false
      });
    }
  };
  _proto.onStartNew = function onStartNew() {
    var onClose = this.props.onClose;
    this.resetConfigCode(onClose);
  };
  _proto.redirectToSavedConfig = function redirectToSavedConfig() {
    var getConfigSaveCode = this.state.getConfigSaveCode;
    if (getConfigSaveCode && getConfigSaveCode.url && typeof window !== 'undefined') {
      window.location = getConfigSaveCode.url;
    }
  };
  _proto.resetConfigCode = function resetConfigCode(callback) {
    this.setState({
      getConfigSaveCode: {},
      inputValue: '',
      error: false,
      openTooltip: false
    }, callback);
  };
  _proto.toggleTooltip = function toggleTooltip() {
    var openTooltip = this.state.openTooltip;
    this.setState({
      openTooltip: !openTooltip
    });
  };
  _proto.submitCode = /*#__PURE__*/function () {
    var _submitCode = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var inputValue, _this$props, client, market, language, variables, _yield$client$query, getConfigSaveCode;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              inputValue = this.state.inputValue;
              _this$props = this.props, client = _this$props.client, market = _this$props.market, language = _this$props.language;
              _context.prev = 2;
              variables = {
                market: market,
                language: language,
                code: inputValue
              };
              _context.next = 6;
              return client.query({
                query: getShareCode,
                variables: variables
              });
            case 6:
              _yield$client$query = _context.sent;
              getConfigSaveCode = _yield$client$query.data.getConfigSaveCode;
              this.setState({
                getConfigSaveCode: getConfigSaveCode
              });
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              this.setState({
                getConfigSaveCode: {
                  code: null
                }
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 11]]);
    }));
    function submitCode() {
      return _submitCode.apply(this, arguments);
    }
    return submitCode;
  }();
  _proto.renderStep = function renderStep() {
    var _this$props2 = this.props,
      theme = _this$props2.theme,
      _this$props2$enterCod = _this$props2.enterCodePopup,
      enterCodePopup = _this$props2$enterCod === void 0 ? {} : _this$props2$enterCod;
    var _this$state = this.state,
      openTooltip = _this$state.openTooltip,
      getConfigSaveCode = _this$state.getConfigSaveCode;
    var isConfigSaveEmpty = (0, _isEmpty2["default"])(getConfigSaveCode);
    var isCodeEmpty = (0, _isEmpty2["default"])(getConfigSaveCode.code);

    // Please enter the code for your saved car
    if (isConfigSaveEmpty) {
      var _clsx;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _enterCode["default"].inputContainer
      }, /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
        className: _enterCode["default"].inputInner,
        inputClassName: (0, _clsx4["default"])(_enterCode["default"].input, theme.headingTwo),
        labelClassName: (0, _clsx4["default"])(_enterCode["default"].label),
        theme: theme,
        type: "text",
        name: "enterCode",
        label: enterCodePopup.codeEntryPlaceholder,
        onError: this.handleError,
        onChange: this.handleChange,
        onKeyUp: this.handleEnter
      }), openTooltip && /*#__PURE__*/_react["default"].createElement("div", {
        className: _enterCode["default"].questionIconPopup
      }, /*#__PURE__*/_react["default"].createElement("img", {
        tabIndex: 0
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        ,
        role: "button",
        className: _enterCode["default"].closeIcon,
        src: _close["default"],
        alt: "close",
        onClick: this.toggleTooltip,
        onKeyDown: this.handleKey
      }), /*#__PURE__*/_react["default"].createElement("img", {
        className: _enterCode["default"].triangleIcon,
        src: _triangle["default"],
        alt: "triangleIcon"
      }), /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        html: enterCodePopup.codeEntryTooltip,
        format: "inherit",
        theme: theme
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx4["default"])(_enterCode["default"].questionIconWrapper, (_clsx = {}, _clsx[_enterCode["default"].questionIconWrapperActive] = openTooltip, _clsx))
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _enterCode["default"].questionIcon,
        title: "question mark",
        onClick: this.toggleTooltip,
        role: "presentation"
      }, "?"))));
    }
    if (isCodeEmpty) {
      return /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _clsx4["default"])(theme.bodyCopy, _enterCode["default"].description)
      }, enterCodePopup.promptErrorMessage);
    }

    // Continue with your last configuration?
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _get2["default"])(getConfigSaveCode, 'vehicle.vehicleImage.image') && /*#__PURE__*/_react["default"].createElement("img", {
      className: _enterCode["default"].vehicleImg,
      src: (0, _get2["default"])(getConfigSaveCode, 'vehicle.vehicleImage.image'),
      alt: (0, _get2["default"])(getConfigSaveCode, 'vehicle.vehicleImage.altText')
    }), /*#__PURE__*/_react["default"].createElement("h5", {
      className: _enterCode["default"].carInfo
    }, (0, _get2["default"])(getConfigSaveCode, 'vehicle.name')), /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _clsx4["default"])(theme.bodyCopy, _enterCode["default"].description)
    }, (0, _get2["default"])(getConfigSaveCode, 'model.engineSize'), "\xA0", (0, _get2["default"])(getConfigSaveCode, 'model.fuelType'), "\xA0\u2022 \xA0", (0, _get2["default"])(getConfigSaveCode, 'model.drivetrain'), "\xA0\u2022\xA0", (0, _get2["default"])(getConfigSaveCode, 'model.transmissionType')));
  };
  _proto.renderPromptLabel = function renderPromptLabel() {
    var _this$props$enterCode = this.props.enterCodePopup,
      enterCodePopup = _this$props$enterCode === void 0 ? {} : _this$props$enterCode;
    var getConfigSaveCode = this.state.getConfigSaveCode;
    if ((0, _isEmpty2["default"])(getConfigSaveCode)) {
      return enterCodePopup.codeEntryHeadingText;
    }
    if ((0, _isEmpty2["default"])(getConfigSaveCode.code)) {
      return enterCodePopup.promptErrorMessageHeading;
    }
    return enterCodePopup.promptHeadingText;
  };
  _proto.render = function render() {
    var _clsx2, _clsx3;
    var _this$props3 = this.props,
      theme = _this$props3.theme,
      show = _this$props3.show,
      _this$props3$enterCod = _this$props3.enterCodePopup,
      enterCodePopup = _this$props3$enterCod === void 0 ? {} : _this$props3$enterCod;
    var _this$state2 = this.state,
      error = _this$state2.error,
      inputValue = _this$state2.inputValue,
      getConfigSaveCode = _this$state2.getConfigSaveCode;
    var showClass = show ? _enterCode["default"].show : '';
    var isConfigSaveEmpty = (0, _isEmpty2["default"])(getConfigSaveCode);
    var isCodeNull = (0, _isNull2["default"])(getConfigSaveCode.code);
    var isCodeEmpty = (0, _isEmpty2["default"])(getConfigSaveCode.code);
    var shouldSubmit = isConfigSaveEmpty;
    var shouldRedirect = Boolean(!isConfigSaveEmpty && getConfigSaveCode.code);
    var startNewCtaClasses = (0, _clsx4["default"])(_enterCode["default"].startNewCtaLink, (_clsx2 = {}, _clsx2[_enterCode["default"].startNewCtaMain] = isCodeNull, _clsx2));
    var startNewCtaData = {
      label: enterCodePopup.startNewLabel,
      priority: isCodeNull ? _themeProvider.themePriority.MEDIUM : _themeProvider.themePriority.LOW
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_enterCode["default"].wrapper, showClass),
      "aria-modal": "true",
      role: "dialog"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_enterCode["default"].wrapperInner, (_clsx3 = {}, _clsx3[_enterCode["default"].expireWrapper] = isCodeNull, _clsx3[_enterCode["default"].carInfo] = !isCodeEmpty, _clsx3[_enterCode["default"].redirect] = shouldRedirect, _clsx3))
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: (0, _clsx4["default"])(_enterCode["default"].closeIcon, _enterCode["default"].closeIconMain),
      src: _close["default"],
      alt: "close",
      onClick: this.onStartNew,
      role: "presentation"
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: _enterCode["default"].title
    }, this.renderPromptLabel()), /*#__PURE__*/_react["default"].createElement("div", {
      className: _enterCode["default"].info
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _enterCode["default"].inputWrapper
    }, this.renderStep()), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_enterCode["default"].ctaWrapper, shouldSubmit ? _enterCode["default"].enterCodeCTAWrapper : _enterCode["default"].continueConfigCTAWrapper)
    }, shouldSubmit && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      key: "1",
      spanClasses: [_enterCode["default"].btnWrapper, _enterCode["default"].firstCTA],
      theme: theme,
      data: {
        label: enterCodePopup.continueLabel,
        priority: 'critical'
      },
      disabled: (0, _isEmpty2["default"])(inputValue) || error,
      classes: [_enterCode["default"].continueCtaLink],
      clickEvent: this.submitCode
    }), shouldRedirect && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      key: "2",
      spanClasses: [_enterCode["default"].btnWrapper, _enterCode["default"].firstCTA],
      theme: theme,
      data: {
        label: enterCodePopup.continueLabel,
        priority: 'critical',
        url: getConfigSaveCode.url
      },
      classes: [_enterCode["default"].continueCtaLink]
    }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      spanClasses: [_enterCode["default"].btnWrapper, _enterCode["default"].secondCTA],
      theme: theme,
      data: startNewCtaData,
      classes: [startNewCtaClasses],
      clickEvent: this.onStartNew
    }))))), /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx4["default"])(_enterCode["default"].overlay, showClass),
      type: "button",
      onClick: this.onStartNew
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _enterCode["default"].elementInvisible
    }, "close")));
  };
  return EnterCode;
}(_react["default"].PureComponent);
exports["default"] = EnterCode;
EnterCode.displayName = 'EnterCode';